import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@cnt-workspace/data-access';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLabel,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

/**
 * Admin shell: toolbar + routed content. The side menu (`admin-header`) lives
 * at the app root, not here — this component is destroyed and recreated on
 * every top-level navigation (each admin route renders it directly), and
 * Ionic's menu controller doesn't reliably re-register a menu that's
 * repeatedly torn down and rebuilt. Session comes from cnt-landing's
 * AuthService.
 */
@Component({
  selector: 'admin-layout',
  standalone: true,
  imports: [
    AsyncPipe,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonLabel,
    IonMenuButton,
    IonTitle,
    IonToolbar,
    RouterOutlet,
  ],
  template: `
    <div class="page">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
          <ion-title>CurbNTurf Admin</ion-title>
          <ion-buttons slot="end">
            @if (auth.currentUser$ | async; as user) {
              <ion-label class="admin-user">{{ user.firstName }} {{ user.lastName }}</ion-label>
            }
            <ion-button (click)="logout()">
              <ion-label>Log Out</ion-label>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content fullscreen class="ion-padding">
        <router-outlet></router-outlet>
      </ion-content>
    </div>
  `,
  styles: [
    `
      /* Full-height column for the header + scrolling content. */
      .page {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      ion-header {
        background-color: #fff;
      }
      .admin-user {
        margin-right: 12px;
        font-size: 14px;
      }
    `,
  ],
})
export class AdminLayoutComponent {
  readonly auth = inject(AuthService);

  logout(): void {
    void this.auth.signOut('You have logged out');
  }
}
